module.exports = __webpack_public_path__ + "static/media/louis-hansel-ZwpX0AJ7GV8-unsplash_mobile.80e281c4.jpg";